import React, { useState, useEffect, useContext, useRef } from "react"
import intl from "react-intl-universal"

import Button from "../../atoms/Button"
import SearchIcon from "../../../assets/icons/SearchIcon"
import FilterSelect from "../../atoms/FilterSelect"
import SwitchComponent from "../../atoms/Switch"
import styles from "./index.module.scss"
import SearchBar from "../../atoms/SearcBar"
import Container from "../../atoms/Container"
import RcmpCardEllipsis from "../../atoms/Ellipsis"
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon"
import { Link } from "react-router-dom"
import { HistoryIcon } from "../../../assets/icons/HistoryIcon"
import { Typography } from "@stardust-ds/react"
import FilterIcon from "../../../assets/icons/FilterIcon"
import CloseIcon from "../../../assets/icons/CloseIcon"
import RcmpDatePicker from "../../atoms/DatePicker"
import Input from "../../atoms/Input"
import Select from "../../atoms/Select"
import ModalFilter from "../ModalFilter"
import BoardContext from "../../../contexts/Board"
import { FilterContext } from "../../../contexts/Filter"
import { FieldsContext } from "../../../contexts/Fields"
import ListViewBlocksIcon from "../../../assets/icons/ListViewBlocksIcon"
import CollumnsViewBlocks from "../../../assets/icons/CollumnsViewBlocks"
import { List } from "antd"
import PlayIconModules from "../../../assets/icons/playIconModules"
import RcmpModalVideosTutorials from "../ModalVideosTutorials"
import { useAppearanceContext } from "../../../contexts/Appearance"

function RcmpContentBlankDescription(props) {
  const { cLabel, cDescription } = props

  if (!cDescription) return null

  return (
    <div className={styles.descriptionContainer}>
      <Container>
        <p>
          <span className={styles.label}>{cLabel} </span>
          {cDescription}
        </p>
      </Container>
    </div>
  )
}

export default function ContentBlank(props) {
  const [searchActive, setSearchActive] = useState(true)
  const [bFilterHasActive, fnSetBFilterHasActive] = useState(false)
  const [bVisibleCtext, fnSetBVisibleCtext] = useState(true)
  const [bScrolledHeader, fnSetBScrolledHeader] = useState(false)
  const [bFilterHasOpen, fnSetBFilterHasOpen] = useState(false)
  const { oCurrentBoard, oBoardRes } = useContext(BoardContext)
  const { aAllFields, fnGetFields } = useContext(FieldsContext)
  const { fnCleanUpFilters } = useContext(FilterContext)
  const { oConfig: oConfigWL } = useAppearanceContext()
  const {
    fnSetBisOpenModal,
    children,
    setSearchTerm,
    onChangeOrder,
    selectedOrder,
    cLabelDescription,
    cDescription,
    aOrderOptions,
    bDisableButton = false,
    sButtonLabel,
    bCloseSearchTerm,
    aEllipsisContent,
    bSwitchable,
    fnOnChangeSwitch,
    nEizeEllipsis,
    variantBtn,
    bShowButtonForm,
    bShowFilterButtom,
    bDisableActions,
    customButtons,
    bArrowLeftGoBack = false,
    bSwitchAtive = false,
    cPathGoBack,
    cLabelGoBack,
    cIconLeftInsideBtn,
    cWidthBtn,
    bValueSwitch,
    bVisibleIconSearch = false,
    cText,
    bShowHistory = false,
    fnHandleOpenModal,
    className,
    bCanChange = true,
    bCanSearch = true,
    cHeaderTitle,
    bShowFilter,
    elHeaderChildren,
    nBlockViewMode = 0,
    fnChangeBlocksView,
    bChangeViewMode = false,
    bShowBtnTableReference,
    cBtnTableReference,
    fnBtnTableReference,
  } = props
  const bHasVideoTutorial =
    (props.bHasVideoTutorial ?? false) && oConfigWL != null && !oConfigWL.nWlpnId

  const handleSwitchChange = (e) => {
    fnOnChangeSwitch({
      bDone: e,
      page: 1,
      bUpdateList: false,
    })
  }

  const headerContainerRef = useRef(null)

  useEffect(() => {
    let scrollTimeout

    const handleScroll = () => {
      if (bScrolledHeader) return
      fnSetBScrolledHeader(true)

      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(() => {
        fnSetBScrolledHeader(false)
      }, 100)
    }

    const headerContainer = headerContainerRef.current
    if (headerContainer) {
      headerContainer.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (headerContainer) {
        headerContainer.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  const handleHiddenSearch = (...args) => {
    setSearchTerm("")
    setSearchActive(args)
  }
  const fnHandleCreateFilteredFields = () => {
    const oBoardModel = oCurrentBoard?.board_model || oCurrentBoard.data[0]?.board_model
    const fields = oBoardModel?.fields
    const filteredData = fields?.filter(
      (field) =>
        field.field.opfd_cslug !== "act_responsibles" &&
        field.field.opfd_cslug !== "data_de_conclusao" &&
        field.field.opfd_cslug !== "data_de_criacao",
    )
    return filteredData?.map((field) => field.field) || []
  }

  const fnHandleGetRequiredFields = () => {
    const filteredData = aAllFields?.filter(
      (field) =>
        field.opfd_cslug === "act_responsibles" ||
        field.opfd_cslug === "data_de_conclusao" ||
        field.opfd_cslug === "data_de_criacao",
    )
    return filteredData || [] /* filteredData.map((field) => field.field) || */
  }
  useEffect(() => {
    fnGetFields()
  }, [])
  useEffect(() => {
    if (bCloseSearchTerm) {
      setSearchTerm("")
      setSearchActive(true)
    }
  }, [bCloseSearchTerm])

  const bShowButton = typeof fnSetBisOpenModal === "function"

  function fnOpenSearch(e) {
    if (bDisableActions) return

    setSearchActive((e) => !e)
  }
  const fnHandleOpenFilter = () => {
    if (!oCurrentBoard) return
    fnSetBFilterHasOpen((prev) => !prev)
    fnSetBVisibleCtext(false)
  }
  const fnHandleActivateFilter = () => {
    fnSetBFilterHasActive((prev) => true)
    fnSetBFilterHasOpen((prev) => !prev)
  }
  const fnHandleClearFilter = () => {
    fnCleanUpFilters()
    fnSetBFilterHasActive((prev) => false)
    fnSetBFilterHasOpen((prev) => !prev)
  }
  const cSearchIconClass = bDisableActions ? styles.disableSearch : styles.activeInput

  const RcmpArrowLeftVisible = () => {
    if (!searchActive) {
      return null
    } else if (bArrowLeftGoBack) {
      return (
        <div className={styles.boxLabelGoBack}>
          <Link to={cPathGoBack}>
            <ArrowLeftIcon fill="#000" />

            <span>{cLabelGoBack}</span>
          </Link>
        </div>
      )
    }
  }

  function fnChangeBlocksViewMode(e, data) {
    e.preventDefault()
    e.stopPropagation()
    fnChangeBlocksView(data)
  }
  return (
    <div
      className={`${styles.dasboardContainer} ${
        nBlockViewMode === 1 ? styles.kanbanContainer : ""
      }`}
    >
      <div className={styles.contentContainer}>
        <div
          className={`${styles.headerContainer} ${className} ${
            nBlockViewMode === 1 ? styles.kanbanHeader : ""
          }`}
          ref={headerContainerRef}
        >
          <div className={bHasVideoTutorial ? styles.leftSideHeaderArea : ""}>
            {bHasVideoTutorial && !bArrowLeftGoBack && (
              <RcmpModalVideosTutorials className={styles.videoTutorialIcon} />
            )}
            {RcmpArrowLeftVisible()}

            <div className={styles.leftArea}>
              {searchActive && bSwitchable && !bFilterHasActive && (
                <SwitchComponent
                  cDisabledText={intl.get("BlocksPage.done_activities")}
                  bSingleOption={true}
                  onChange={(e) => handleSwitchChange(e)}
                  disabled={bDisableActions}
                />
              )}
              {bChangeViewMode && (
                <div className={styles.viewsBlocks}>
                  <aside
                    className={
                      nBlockViewMode === 0
                        ? styles.changeViewAreaSelected
                        : styles.changeViewArea
                    }
                  >
                    <ListViewBlocksIcon onClick={(e) => fnChangeBlocksViewMode(e, 0)} />
                  </aside>
                  <div className={styles.verticalBar} />
                  <aside
                    className={
                      nBlockViewMode === 1
                        ? styles.changeViewAreaSelected
                        : styles.changeViewArea
                    }
                  >
                    <CollumnsViewBlocks onClick={(e) => fnChangeBlocksViewMode(e, 1)} />
                  </aside>
                </div>
              )}
              {searchActive && (
                <div className={styles.headerSelect}>
                  <FilterSelect
                    data={aOrderOptions}
                    onChange={onChangeOrder}
                    selected={selectedOrder}
                  />
                </div>
              )}
            </div>
          </div>
          {/* aki */}
          {!!cText && bVisibleCtext && (
            <div className={styles.containerText}>
              <h1>{cText}</h1>
            </div>
          )}

          {searchActive ? (
            <div className={styles.headerRigth}>
              {customButtons &&
                customButtons.map((button, index) =>
                  React.cloneElement(button, { key: `button-${index}` }),
                )}
              {bShowButton && (
                <>
                  {bSwitchAtive && (
                    <SwitchComponent
                      cSizeFont="1rem"
                      width="8rem"
                      cDisabledText={intl.get("ciq.list_analytes.inactive")}
                      bSingleOption={true}
                      onChange={(e) =>
                        fnOnChangeSwitch((prev) => ({ ...prev, bDone: e, page: 1 }))
                      }
                      disabled={bDisableActions}
                      value={bValueSwitch}
                    />
                  )}

                  <Button
                    onClick={fnSetBisOpenModal}
                    iconLeft={!cIconLeftInsideBtn ? "plus" : cIconLeftInsideBtn}
                    // className={variantBtn ? styles.outline : styles.addCardButton}
                    variant={variantBtn ? variantBtn : "primary"}
                    style={{
                      width: cWidthBtn ? cWidthBtn : "144px",
                      cursor: bDisableButton ? "not-allowed" : "pointer",
                    }}
                  >
                    {sButtonLabel}
                  </Button>
                </>
              )}
              <AdvancedFilter
                bShowFilter={bShowFilter}
                bFilterHasActive={bFilterHasActive}
                cSearchIconClass={cSearchIconClass}
                fnHandleOpenFilter={fnHandleOpenFilter}
                fnHandleCleanFilter={fnHandleClearFilter}
                fnOpenSearch={fnOpenSearch}
                bCanSearch={bCanSearch}
                oCurrentBoard={oCurrentBoard}
              />
              {bVisibleIconSearch && (
                <div className={styles.search}>
                  <SearchIcon
                    fill="#6CB6E3"
                    onClick={fnOpenSearch}
                    className={cSearchIconClass}
                  />
                </div>
              )}

              {aEllipsisContent && bCanChange && (
                <RcmpCardEllipsis
                  className={styles.ellipsisContainer}
                  aOptions={aEllipsisContent}
                  fill={"#6CB6E3"}
                  size={nEizeEllipsis}
                  bDisabled={bDisableActions}
                  bIsExternalCloseCard={bScrolledHeader}
                />
              )}
            </div>
          ) : (
            <SearchBar
              fnSetBVisibleCtext={fnSetBVisibleCtext}
              setSearchTerm={setSearchTerm}
              setSearchActive={handleHiddenSearch}
            />
          )}

          {elHeaderChildren && elHeaderChildren}
          {bShowBtnTableReference && (
            <div className={styles.containerTableReference}>
              <Button
                onClick={fnBtnTableReference}
                variant="outline"
                style={{
                  width: cWidthBtn ? cWidthBtn : "144px",
                  cursor: bDisableButton ? "not-allowed" : "pointer",
                }}
              >
                {cBtnTableReference}
              </Button>
              <div className={styles.containerHistory} onClick={fnHandleOpenModal}>
                {<HistoryIcon />}
              </div>
            </div>
          )}
          {bShowHistory && (
            <div className={styles.containerHistory} onClick={fnHandleOpenModal}>
              {<HistoryIcon />}
            </div>
          )}
        </div>

        <RcmpContentBlankDescription
          cLabel={cLabelDescription}
          cDescription={cDescription}
        />
        <div className={styles.content} id={"blankSpaceContent"}>
          {children}
        </div>
      </div>
      {bFilterHasOpen && (
        <ModalFilter
          fnHandleOpenFilter={fnHandleOpenFilter}
          fnHandleActivateFilter={fnHandleActivateFilter}
          fnHandleClearFilter={fnHandleClearFilter}
          aAllFieldsFiltered={fnHandleCreateFilteredFields()}
          aRequiredFields={fnHandleGetRequiredFields()}
        />
      )}
    </div>
  )
}

const AdvancedFilter = ({
  bShowFilter,
  bFilterHasActive,
  fnHandleOpenFilter,
  fnHandleCleanFilter,
  fnOpenSearch,
  cSearchIconClass,
  bCanSearch,
  oCurrentBoard,
}) => {
  if (bShowFilter) {
    return (
      <>
        {!bFilterHasActive && bShowFilter ? (
          <>
            <div
              onClick={fnHandleOpenFilter}
              style={{
                cursor: oCurrentBoard !== null ? "pointer" : "not-allowed",
                PointerEvent: oCurrentBoard !== null ? "" : "none",
                opacity: oCurrentBoard !== null ? "100%" : ".5",
              }}
            >
              <FilterIcon
                style={{ cursor: oCurrentBoard !== null ? "pointer" : "not-allowed" }}
                fill="none"
              />
            </div>
            {bCanSearch && (
              <div className={styles.search}>
                <SearchIcon
                  fill="#6CB6E3"
                  onClick={fnOpenSearch}
                  className={cSearchIconClass}
                />
              </div>
            )}
          </>
        ) : (
          <button className={styles.filterIcon} onClick={fnHandleOpenFilter}>
            <FilterIcon
              style={{ cursor: "pointer" }}
              fill="none"
              stroke={bFilterHasActive ? "#1ECB4F" : undefined}
            />
            Filtro ativo
            <CloseIcon
              fill="#1ECB4F"
              height="22px"
              width="22px"
              onClick={(e) => {
                e.stopPropagation()
                fnHandleCleanFilter()
              }}
            />
          </button>
        )}
      </>
    )
  }
  return (
    <div className={styles.search}>
      {bCanSearch && (
        <SearchIcon fill="#6CB6E3" onClick={fnOpenSearch} className={cSearchIconClass} />
      )}
    </div>
  )
}
